import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { IconFileName } from '../../components/IconFileName.js';
import { isDeviceConnectionType } from '../../../../../connections/connections.utils.js';
import { ColorLabel } from '../../components/ColorLabel.js';
import { ResourceGridViewLoadingIndicator } from '../components/ResourceGridViewLoadingIndicator.js';
import { useResourceFolderDataContextSafe } from '../../../../../resource-detail/components/context/resourceDataContext.js';
import { containerPreviewCompact } from '../cssPreviewContainer.js';
import { cssAspectRatio } from '../sharedCss.js';
import { ImgFolderDevice, ImgFolder } from '@fabric-app/icons/old';

const ResourcePreviewFolder = () => {
  const { resource, fullName, placeholderName } = useResourceFolderDataContextSafe();
  return /* @__PURE__ */ jsxs(GridFolderIconWrapper, {
    children: [
      /* @__PURE__ */ jsx(ResourceGridViewLoadingIndicator, {
        resource
      }),
      /* @__PURE__ */ jsx(ColorLabel, {
        absPosition: "inside-top-left"
      }),
      isDeviceConnectionType(resource.root?.subtype) ? /* @__PURE__ */ jsx(FolderImage, {
        src: ImgFolderDevice,
        alt: "Device Folder",
        draggable: false
      }) : /* @__PURE__ */ jsx(FolderImage, {
        src: ImgFolder,
        alt: "Folder",
        draggable: false
      }),
      /* @__PURE__ */ jsx(IconFileName, {
        title: fullName || placeholderName
      })
    ]
  });
};
const GridFolderIconWrapper = styled.div.attrs({
  "data-preview-content-wrapper": "folder"
}).withConfig({
  displayName: "ResourcePreviewFolder__GridFolderIconWrapper",
  componentId: "sc-a11b1deb-0"
})([
  `width:100%;height:100%;display:flex;align-items:center;flex-direction:column;flex-grow:1;gap:1rem;overflow:hidden;justify-content:center;padding:0.75rem;border-radius:var(--preview-content-border-radius,1.125rem);position:relative;padding:0.75rem;`,
  `;`
], cssAspectRatio);
const FolderImage = styled.img.withConfig({
  displayName: "ResourcePreviewFolder__FolderImage",
  componentId: "sc-a11b1deb-1"
})([
  `max-height:7rem;max-width:7rem;height:auto;width:auto;`,
  `{max-height:4rem;max-width:4rem;}`
], containerPreviewCompact);

export { FolderImage, GridFolderIconWrapper, ResourcePreviewFolder };
//# sourceMappingURL=ResourcePreviewFolder.js.map
